<h5 class="font-semibold text-primary-900 uppercase">{{ "GLOBAL.LAMELLA_AREA" | translate }}
    #{{ lamellaArea().order }}</h5>
    {{ lamellaAreaStore.getLamelareaGroup(lamellaArea().groupId).name  }}

<div class="grid grid-cols-10 w-full gap-2 ">
    <div class="flex-col">
        <!--<img src="assets/images/lamella-placeholder.png" class="col-span-2 w-full">

        <div class="mt-2">
            {{"QUANTITY.AREA_MEASURES" | translate}}: <br> {{ lamellaArea().width }} x {{ lamellaArea().height }} mm
        </div>

        <div class="mt-2">
            @if(lamellaArea().orientation == "horizontal") {
                {{"QUANTITY.LAMELLA_AREA_MEASURES" | translate}}: <br> {{ lamellaArea().width }} x {{ Math.floor(lamellaArea().height / 26.5)* 26.5}} mm
            } @else {
                {{"QUANTITY.LAMELLA_AREA_MEASURES" | translate}}: <br> {{ Math.floor(lamellaArea().height / 26.5)* 26.5 }} x {{ lamellaArea().width }} mm
            }

        </div>-->
    </div>


    <div class="col-span-10 space-y-8">
        {{"QUANTITY.AREA_MEASURES" | translate}}: {{ lamellaArea().width }} x {{ lamellaArea().height }} mm<br>
        @if(lamellaArea().orientation == "horizontal") {
            {{"QUANTITY.LAMELLA_AREA_MEASURES" | translate}}:{{ lamellaArea().width }} x {{ Math.floor(lamellaArea().height / 26.5)* 26.5}} mm<br>
        } @else {
            {{"QUANTITY.LAMELLA_AREA_MEASURES" | translate}}:{{ Math.floor(lamellaArea().height / 26.5)* 26.5 }} x {{ lamellaArea().width }} mm<br>
        }
        <div>
            <div class="flex p-1 gap-2 text-center">
                <img src="assets/images/icons/lamella.svg" width="24" height="24" alt="lamella"/>
                <h6 class="text-gray-500 font-semibold uppercase self-center">
                   {{"LAMELLAE" | translate}}
                </h6>
            </div>
            <hr class="h-0.5 border-t-0 bg-gray-500" />
            <table role="table" class="w-full text-sm text-left rtl:text-right text-gray-500">
                <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr class="border-b">
                        <th scope="col" class="px-6 py-3"></th>
                        <th scope="col" class="px-6 py-3">{{"TABLES.LAMELLA.PRODUCT_FAMILY" | translate}}</th>
                        <th scope="col" class="px-6 py-3">{{"TABLES.LAMELLA.LAMELLA" | translate}}</th>
                        <th scope="col" class="px-6 py-3">{{"TABLES.LAMELLA.SURFACE" | translate}}</th>
                        <th scope="col" class="px-6 py-3">{{"TABLES.LAMELLA.COLOR" | translate}}</th>
                        <th scope="col" class="px-6 py-3">{{"TABLES.LAMELLA.QUANTITY" | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    @for(lamellaSetResult of lamellaSetsResults(); track lamellaSetResult.id) {
                        <tr class="border-b">
                            <td class=""><img [src]="'/api/storage/view/'+lamellaSetResult.image" class="w-32"></td>
                            <th scope="row" class="px-6 py-4 font-medium">{{ lamellaSetResult.productFamily }}</th>
                            <td class="px-6 py-4">{{ lamellaSetResult.name }}</td>
                            <td class="px-6 py-4">{{ lamellaSetResult.material | translate }}</td>
                            <td class="px-6 py-4">
                                <div class="colorIndicator inline-block w-[20px] h-[20px] mr-2 border border-solid border-gray-300 rounded" [style.background-color]=lamellaSetResult.color.HEX></div>
                                @if (lamellaSetResult.material == "Powder Coated") {
                                    RAL {{ lamellaSetResult.color.RAL }}
                                }
                                @else {
                                    {{ lamellaSetResult.color.RAL }}
                                }
                            </td>
                            <td class="px-6 py-4">{{ lamellaSetResult.amount / 1000 | number:'1.0-2' }} m</td>
                        </tr>
                    }

                </tbody>
            </table>

        </div>

    <!-- PIILOTETAAN TOISTAISEKSI
        <div>
            <div class="flex p-1 gap-2 text-center">
                <img src="assets/images/icons/screw.svg" width="24" height="24" />
                <h6 class="text-gray-500 font-semibold uppercase self-center">
                    tarvikkeet
                </h6>
            </div>

            <hr class="h-0.5 border-t-0 bg-gray-500" />

            <table role="table" class="w-full text-sm text-left rtl:text-right text-gray-500">
                <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                <tr class="border-b">
                    <th scope="col" class="px-6 py-3">tarvike</th>
                    <th scope="col" class="px-6 py-3">malli/tuotekoodi</th>
                    <th scope="col" class="px-6 py-3">määrä</th>
                    <th scope="col" class="px-6 py-3">yksikkö</th>
                </tr>
                </thead>
                <tbody>
                <tr class="border-b">
                    <th scope="row" class="px-6 py-4 font-medium">arvo</th>
                    <td class="px-6 py-4">arvo</td>
                    <td class="px-6 py-4">arvo</td>
                    <td class="px-6 py-4">arvo</td>
                </tr>
                <tr class="border-b">
                    <th scope="row" class="px-6 py-4 font-medium">arvo</th>
                    <td class="px-6 py-4">arvo</td>
                    <td class="px-6 py-4">arvo</td>
                    <td class="px-6 py-4">arvo</td>
                </tr>
                </tbody>
            </table>
        </div>-->
    </div>
</div>
<div class="w-full h-3.5"  [style.page-break-before]="pageBreak() ? 'always' : null"></div>
